const routeLoaders = {
  '/plataforma-admin': () => import('pages/SuperAdminCompanies'),
  '/dashboard': () => import('pages/Dashboard'),
  '/active-processes': () => import('pages/ActiveProcesses'),
  '/legal-kanban': () => import('pages/Tasks'),
  '/financeiro': () => import('pages/Financeiro'),
  '/monitors': () => import('components/Forms'),
  '/clients': () => import('pages/Clients'),
  '/schedule': () => import('pages/Schedule'),
  '/concluded-processes': () => import('pages/ConcludedProcesses'),
  '/upload': () => import('pages/UploadData'),
  '/registrations': () => import('pages/Registrations'),
  '/settings': () => import('pages/Settings'),
  '/company': () => import('pages/Company'),
  '/notifications': () => import('pages/Notifications'),
  '/perfil': () => import('pages/Perfil'),
  '/desempenho': () => import('pages/Desempenho'),
  '/business-intelligence': () => import('pages/BusinessIntelligence'),
  '/publications': () => import('pages/Publications'),
  // Patrimônio (gratuito: DJEN + DataJud). A consulta paga do Escavador fica em pages/ConsultaEnvolvido
  '/consulta-envolvido': () => import('pages/Patrimonio'),
  '/admin-notifications': () => import('pages/AdminNotifications'),
  '/auditoria': () => import('pages/Auditoria'),
  '/document-templates': () => import('pages/DocumentTemplates'),
}

export const getRouteLoader = path => routeLoaders[path]

export const preloadRoute = path => {
  const loader = routeLoaders[path]
  if (loader) loader().catch(() => {})
}

